import { ScriptService } from './script.service'

interface IYouTubeScriptService {
    loadYTIframeAPI: () => Promise<boolean>
}

export class YouTubeScriptService implements IYouTubeScriptService {
    private youtubeLoaded = false

    public async loadYTIframeAPI(): Promise<boolean> {
        if (this.youtubeLoaded === false) {
            const firstScriptTag = document.getElementsByTagName('script')[0]
            if (firstScriptTag) {
                await ScriptService.getInstance()
                    .loadScript({
                        name: 'youtubeIframeAPI',
                        src: 'https://www.youtube.com/iframe_api',
                        loaded: false
                    })
                    .catch((error: Error) => console.error(error))
            }
            this.youtubeLoaded = true
        }
        return this.youtubeLoaded
    }
}
